import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StateService } from '../../../../shared/service/state.service';
import { FileService } from '../../services/file.service';
import { first } from 'rxjs';
import { DocumentBack } from '../../../../core/models/document-back.model';
import { File, Folder, Module, Project } from '../../../../core/models/project.model';

@Component({
  selector: 'refactor-pages-show-code',
  standalone: false,
  templateUrl: './show-code.component.html',
  styleUrl: './show-code.component.scss'
})
export class ShowCodeComponent implements OnInit{

  uploadedFile: File[] | null = null;
  documentList: DocumentBack[] = [];
  errorMessage: string = '';
  refactorResponse: any = null
  summary: any[] = [];

  codeEditorOptions = {
    theme: 'vs-dark',
    language: 'json',
    automaticLayout: true
  };

  constructor(
    private router: Router,
    private stateService: StateService,
    private fileService: FileService,
  ) { }

  ngOnInit(): void {
    this.loadUploadedFiles();
    this.loadExtractedDocuments();
  }

  private loadUploadedFiles(): void {
    this.stateService.uploadedFiles$.subscribe(files => {});
  }

  private loadExtractedDocuments(): void {
    this.stateService.extractedDocuments$.subscribe((project:Project|null) => {
      this.documentList = [];
      if(project){
        this.transformTreeToDocumentList(project);
      }
    });
  }

  private transformTreeToDocumentList(project: Project){
    let documents: DocumentBack[]=[];
    project.modules.forEach((module:Module)=>{
      module.folders.forEach((folder:Folder)=>{
        folder.files.forEach((file: File)=>{
          let f = file.name.split('.');
          documents.push({
            fileName:f[0],
            fileExtension:f[1],
            filePath:folder.path,
            fileContent:file.content
          })
        })
      })
    })
  }
  onDownload(): void {
    this.stateService.refactorResponse$.pipe(first()).subscribe(response => {
      if (response?.file?.data) {
        this.refactorResponse = response;
        this.downloadFileFromResponse();
      }
    });
  }

  private downloadFileFromResponse(): void {
    const { data, name, mime } = this.refactorResponse.file;
  }

  returnfileUpload(): void {
    this.router.navigate(['/coding/refactor/upload-files']);
  }
}
